import React, { useState } from 'react'
import { Box, Button, CircularProgress, Tooltip } from '@material-ui/core'
import { useJiraProjectFilter } from './useJiraProjectFilter'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import service from './JiraResourcesService'

export function JiraBoardFilter({ projectKey }: { projectKey: string }) {
  const [reloadCounter, setReloadCounter] = useState(0)
  const filter = useJiraProjectFilter(projectKey, reloadCounter)
  const [updateClicked, setUpdateClicked] = useState(false)
  const [updating, setUpdating] = useState(false)

  function onUpdate(): void {
    setUpdateClicked(true)
    setUpdating(true)
    service.putProjectFilter(projectKey).finally(() => {
      setUpdating(false)
      setReloadCounter(reloadCounter + 1)
    })
  }

  const status = (
    <span style={{ marginRight: 8, verticalAlign: 'middle' }}>
      {filter === null ? (
        <Tooltip title='Missing filter'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      ) : filter?.jql === `project = ${projectKey} ORDER BY Rank ASC` ? (
        <Tooltip title='Standard query'>
          <CheckIcon style={{ color: 'green' }} />
        </Tooltip>
      ) : (
        <Tooltip title='Non standard filter query'>
          <ClearIcon style={{ color: 'red' }} />
        </Tooltip>
      )}
    </span>
  )

  return (
    <Box>
      {typeof filter === 'undefined' ? (
        <CircularProgress size={16} style={{ marginLeft: 8 }} />
      ) : (
        status
      )}
      Filter:{' '}
      {filter === null ? (
        <Button
          variant='text'
          color='primary'
          disabled={updateClicked}
          onClick={() => onUpdate()}
        >
          Update
          {updating ? (
            <CircularProgress size={16} style={{ marginLeft: 8 }} />
          ) : null}
        </Button>
      ) : (
        ''
      )}
      {filter ? (
        <span>
          <Tooltip title={filter.jql}>
            <span>{filter.name}</span>
          </Tooltip>
          {filter.jql === `project = ${projectKey} ORDER BY Rank ASC` ? null : (
            <span>
              <Button
                variant='text'
                color='primary'
                disabled={updateClicked}
                onClick={() => onUpdate()}
              >
                Update
                {updating ? (
                  <CircularProgress size={16} style={{ marginLeft: 8 }} />
                ) : null}
              </Button>
            </span>
          )}
        </span>
      ) : (
        ''
      )}
    </Box>
  )
}
